import React, { useState } from "react";
import { Check, Pencil, X } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

/* Short table nickname shown under the player's photo at live tables (Andar Bahar, 7 Up 7 Down). */
export function NicknameEditor({ user, ta, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(user.nickname || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/auth/nickname", { nickname: val });
      toast.success(data.nickname ? (ta ? `Table பெயர்: ${data.nickname}` : `Table nickname: ${data.nickname}`) : (ta ? "Nickname நீக்கப்பட்டது" : "Nickname removed"));
      setEditing(false); await onSaved?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save"); }
    finally { setBusy(false); }
  };
  if (!editing) {
    return (
      <button onClick={() => { setVal(user.nickname || ""); setEditing(true); }} className="mt-1 inline-flex items-center gap-1 text-[10px] font-bold text-amber-700 bg-amber-50 border border-amber-200 px-2 py-0.5 rounded-full active:scale-95 transition-transform" data-testid="me-nickname-btn">
        🎭 {user.nickname ? <span data-testid="me-nickname-value">{user.nickname}</span> : (ta ? "Table nickname சேர்க்க" : "Set table nickname")}<Pencil className="w-2.5 h-2.5" />
      </button>
    );
  }
  return (
    <div className="mt-1 flex items-center gap-1" data-testid="me-nickname-editor">
      <input value={val} onChange={(e) => setVal(e.target.value.slice(0, 12))} maxLength={12} placeholder={ta ? "3–12 எழுத்து" : "3–12 chars"} autoFocus
        className="flex-1 min-w-0 rl-card px-2 py-1 text-xs font-bold text-slate-900 outline-none" data-testid="me-nickname-input" />
      <button onClick={save} disabled={busy} className="w-7 h-7 rounded-lg bg-emerald-500 text-white flex items-center justify-center" data-testid="me-nickname-save"><Check className="w-3.5 h-3.5" /></button>
      <button onClick={() => setEditing(false)} className="w-7 h-7 rounded-lg bg-slate-200 text-slate-600 flex items-center justify-center" data-testid="me-nickname-cancel"><X className="w-3.5 h-3.5" /></button>
    </div>
  );
}
